import { Calculation } from './calculation';
import { SubCalculation } from './sub-calculations/sub-calculation';
import { TAX_REGIMES, taxRegimeMap } from './types';

export const TaxCalculation = ({
  taxCalculation,
  activeTab,
}: {
  taxCalculation: TAX_REGIMES | undefined;
  activeTab: number | undefined;
}) => {
  const regime = taxRegimeMap[activeTab || 0];
  const regimeData = regime && taxCalculation?.[regime];

  if (!regimeData) {
    return <></>;
  }
  const {
    exemptionsAndDeductionsInSalary,
    healthAndEducationCess,
    incomeTaxInclusiveOfSpecialRate,
    standardDeductions,
    taxable_Income,
    totalIncome,
    grossTax,
    totalDeductions,
    surcharge,
  } = regimeData;

  const newRegime = taxRegimeMap[0];
  const oldRegime = taxRegimeMap[1];

  if (!newRegime || !oldRegime) {
    return <></>;
  }

  return (
    <div className="max-w-[651px] w-full">
      <div className="flex gap-6 sm:block md:gap-2.5 md:flex-wrap">
        <div className="calculation-card md:w-[208px] px-12 pt-7 md:py-2 md:px-2 sm:py-7 pb-0 bg-[#D0E4FE33] rounded-md text-center sm:mt-6 sm:px-6 w-full max-w-[329px] sm:max-w-none md:max-w-none">
          <Calculation
            title="Total income"
            counter={parseInt(totalIncome)}
            classes="sm:text-s-24 font-bold"
          />
          <div className="mt-12 md:mt-6 pb-3">
            <Calculation
              title="Exemption and deduction"
              counter={
                parseInt(exemptionsAndDeductionsInSalary) +
                parseInt(standardDeductions) +
                parseInt(totalDeductions)
              }
              classes="sm:text-s-24 font-bold"
            />
          </div>
          <SubCalculation
            calculations={[
              {
                title: 'Exempt Allowances',
                counter: parseInt(exemptionsAndDeductionsInSalary),
              },
              {
                title: 'Standard Deductions',
                counter: parseInt(standardDeductions),
              },
              {
                title: 'Chapter VI A Deductions',
                counter: parseInt(totalDeductions),
              },
            ]}
          />
        </div>
        <div className="flex md:w-[208px] flex-col justify-between sm:mt-6 w-full max-w-[298px] sm:max-w-none md:max-w-none gap-4">
          <div className="calculation-card px-8 py-6 md:px-2 bg-[#D0E4FE33] rounded-md text-center">
            <Calculation
              title="Taxable income"
              counter={parseInt(taxable_Income)}
              classes="sm:text-s-24 font-bold"
            />
          </div>
          <div className="calculation-card px-8 py-7 md:py-2 md:px-2 sm:px-6 bg-[#D0E4FE33] rounded-md text-center">
            <div className="pb-3">
              <Calculation
                title="Tax payable"
                counter={parseInt(grossTax)}
                headerClasses="font-bold"
                classes="sm:text-s-32 text-s-32 font-bold"
              />
            </div>
            <SubCalculation
              calculations={[
                {
                  title: 'Income tax',
                  counter: parseInt(incomeTaxInclusiveOfSpecialRate),
                },
                {
                  title: 'Surcharge',
                  counter: parseInt(surcharge),
                },
                {
                  title: 'Health and education cess',
                  counter: parseInt(healthAndEducationCess),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
